export class Constants {
	public static readonly eventHandlerNames: string[] = ['onclick', 'onhide', 'onenter', 'onshow', 'onmouseover',
		'onmouseout', 'ontransitionDone', 'onclickToggleOn', 'onclickToggleOff',
		'onstart', 'onstop', 'ontick', 'oncomplete', 'onfinished', 'onclickToggleOn', 'onclickToggleOff', 'onvalidationsucceeded',
		'onvalidationfailed', 'onSuccess', 'onFailure', 'onAllWidgetsValidated'
	];
}
